import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-accounting-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accounting-overview.html',
  styleUrls: ['./accounting-overview.css'],
})
export class AccountingOverviewComponent {}
